<div [ngClass]="classes()"></div>
